// @flow

import React, { type Node, useState, useEffect } from 'react';
import { GlobalStyle } from '@tectonics/commons/look-and-feel/uber/global-style';
import { Container } from '@tectonics/commons/look-and-feel/uber/atom/container';
import { HighlightBox } from '@tectonics/commons/look-and-feel/uber/atom/highlight-box';
import { Button } from '@tectonics/commons/look-and-feel/uber/atom/button';
import { Label } from '@tectonics/commons/look-and-feel/uber/atom/label';
import { InputField } from '@tectonics/commons/look-and-feel/uber/molecule/input-field';
import { Footer } from '@tectonics/commons/look-and-feel/uber/organism/footer';
import type { PageStatus } from '../sodexo-page';
import { type SodexoUserInputValues, useSodexoUserInputValueChangeHandler } from '../../../../meal-voucher/sodexo/user-input-values';
import { useSodexoAuthorizeSubmitHandlerWithStatus } from '../../../../meal-voucher/sodexo/authorize-submit';
import { useSodexoUserInputValidations, type SodexoUserInputValidation } from '../../../../meal-voucher/sodexo/user-input-validations';

interface SodexoFormProps {
  pageStateSetter: (PageStatus | (PageStatus) => PageStatus) => void,
}

export function SodexoForm(props: SodexoFormProps): Node {
  const { pageStateSetter } = props;

  const [sodexoUserInputValues, setSodexoUserInputValues] = useState<SodexoUserInputValues>({
    userChileanRut: '',
  });
  const sodexoUserInputValidations = useSodexoUserInputValidations(sodexoUserInputValues);
  const [handleSubmit, formStatus] = useSodexoAuthorizeSubmitHandlerWithStatus(
    sodexoUserInputValues,
    sodexoUserInputValidations
  );

  const handleSodexoUserInputValueChange = useSodexoUserInputValueChangeHandler(setSodexoUserInputValues);
  useEffect(() => {
    if (formStatus === 'submitting') {
      pageStateSetter('iframe');
    }
  }, [formStatus, pageStateSetter]);

  return (
    <Container style={{background: 'white'}}>
      <GlobalStyle/>
      <form style={{padding: '1em'}} onSubmit={handleSubmit}>
        <Label>Ingrese el RUT del beneficiario para registrar su tarjeta Sodexo en <strong>Uber Eats</strong>:</Label>
        <HighlightBox style={{marginTop: '1em'}}>
          <Line>
            <InputField
              label="RUT"
              placeholder="___ ___ ___ _"
              value={sodexoUserInputValues.userChileanRut}
              onChange={handleSodexoUserInputValueChange('userChileanRut')}
              name="user_chilean_rut"
              error={formStatus === 'validated' ? parseValidationErrors(sodexoUserInputValidations.userChileanRut) : ''}
            />
          </Line>
        </HighlightBox>

        <Button style={{
          display: 'block',
          width: '100%',
          marginTop: '1em',
        }}>
          {formStatus === 'submitting' ? 'ENVIANDO...' : 'ENVIAR RUT'}
        </Button>
      </form>
      <Footer/>
    </Container>
  );
}

function Line({ children, style }: LineProps): Node {
  return (
    <div style={{ ...style, margin: '1em' }}>
      {children}
    </div>
  );
}

type LineProps = {
  children: Node,
  style?: { [string]: string },
};

function parseValidationErrors(submitError: SodexoUserInputValidation): string {
  if (!submitError) {
    return '';
  }
  switch (submitError) {
    case 'empty':
      return 'Ingrese el RUT';
    case 'invalid':
      return 'Documento inválido';
    default:
      return '';
  }
}
